var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-row",style:([_vm.hasBorder ? _vm.getBorder : 'null'])},[_c('div',{staticClass:"col flex-start",style:([_vm.sm])},[_c('p',[_vm._v(_vm._s(_vm.propName))])]),_vm._v(" "),_c('div',{staticClass:"col flex-end animated flipInX",style:([_vm.sm])},[_c('p',{staticClass:"highlight"},[_vm._v(_vm._s(_vm.propValue))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11debd89","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/CardRow.vue
// module id = null
// module chunks = 